var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pentagonWrapper"},[_c('div',{staticClass:"pentagon",class:[_vm.statusCssClass]}),_c('h3',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }